import { useEffect } from 'react';

import { useOAuthStore } from '@/features/auth/store';

import { broadcastTradingSession } from './broadcast';

/**
 * Notifies the lifecycle provider after an OAuth redirect establishes cookies.
 *
 * Keyed on the whole authority-bearing identity, not just `authenticated`: the
 * server only grants OAuth trading authority to a session whose custodial
 * binding is `bound`, and a first login often lands as `unknown`/`unbound`
 * (the chain lookup lagging the fresh association) and is resolved to `bound`
 * by a rebind moments later. That resolution flips nothing in `authenticated`,
 * so without this key the provider never re-read the status and the user was
 * left in demo mode until the next focus event.
 */
const OAuthAuthorityBridge = () => {
    const authorityKey = useOAuthStore((state) =>
        state.me?.authenticated === true
            ? [
                state.me.provider ?? '',
                state.me.accountHash ?? '',
                state.me.bindingState ?? '',
            ].join(':')
            : null,
    );
    useEffect(() => {
        if (authorityKey !== null) {
            broadcastTradingSession({ type: 'changed' });
        }
    }, [authorityKey]);
    return null;
};

export default OAuthAuthorityBridge;
